import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _LinkLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M10 16H7a4 4 0 0 1 0-8h3M16 12H8M14 16h3a4 4 0 0 0 0-8h-3" })));
}
const LinkLight = forwardRef(_LinkLight);
export { LinkLight };
